// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__9lLWV","label":"LabeledBox_label__17-Uh"};